module.exports = __webpack_public_path__ + "static/2efed786253b0d770b66db1a1aec5ddf8cc60c01afaff1d289e21e69f51ff9e6-508543117f14ef6178b8743fbb6dbd32.png";